module.exports = __webpack_public_path__ + "static/media/magnifier.2d710f3a.svg";